// turn number into short eg. 1000 to 1k
export const displayNumber = (num: number, decimals: number, minDecimals?: number) => {
  return Intl.NumberFormat('en-US', {
    notation: "compact",
    maximumFractionDigits: Math.max(decimals, minDecimals ?? 0),
    minimumFractionDigits: minDecimals ?? decimals,
    // minimumSignificantDigits: 2,
    // maximumSignificantDigits: 4
  }).format(num);
}